module.exports = __webpack_public_path__ + "static/img/042_5.06146a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_5.jpg
// module id = fWh1
// module chunks = 1